// @flow
import React, { Component } from 'react';
import ShortUniqueId from 'short-unique-id';
import { loadPaymentWidget, ANONYMOUS } from '@tosspayments/payment-widget-sdk';
import Circles from 'components/common/Loaders/Circles';
import CheckoutTemplate from 'components/checkout/CheckoutTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { track, TRACKING_EVENTS } from 'lib/tracking';
import { buildItemFromCartItem, toNumber } from 'lib/tracking/ecommerce';
import {
  BaseActions,
  CartActions,
  OrdersActions,
  UserActions,
  ShippingAddressesActions,
  TaxInvoiceActions,
} from '../../store/actionCreators';

type Props = {
  cart: any,
  user: any,
  order: any,
  logged: boolean,
  loading: boolean,
  shippingAddresses: any,
  taxInvoice: any,
};

type CheckoutState = {
  checkoutTerms: boolean,
  checkoutPrivacy: boolean,
  checkoutAll: boolean,
  appliedCoupon: any,
  appliedDiscount: any,
  paymentMethod: any,
  addressNameFull: string,
  addressEmail: string,
  addressMobile: string,
  addressPhone: string,
  addressCity: string,
  addressState: string,
  addressAddress1: string,
  addressAddress2: string,
  addressPostCode: any,
  request: any,
  // 발급수단 관련
  selectedPaymentType: string,
  documentaryEvidenceInfo: {
    documentType: string,
    preIssuanceAgreement: boolean,
    name: string,
    contact: string,
    sub_contact: string,
    email: string,
    business_no: string,
    tax_registration_id: string,
    business_item: string,
    business_type: string,
    company_name: string,
    representative_name: string,
    business_address: string,
  },
  // 주문자 정보 라디오 버튼 관련
  ordererInfoType: string,
  savedMyInfo: {
    addressNameFull: string,
    addressEmail: string,
    addressMobile: string,
    addressPhone: string,
  },
  // 배송지 정보 라디오 버튼 관련
  shippingInfoType: string,
  savedRecentAddress: {
    addressShippingNameFull: string,
    addressShippingMobile: string,
    addressState: string,
    addressCity: string,
    addressAddress1: string,
    addressAddress2: string,
    addressPostCode: any,
  },
};

class CheckoutTemplateContainer extends Component<Props, CheckoutState> {
  state = {
    checkoutTerms: false,
    checkoutPrivacy: false,
    checkoutAll: false,
    appliedCoupon: '',
    appliedDiscount: '',
    paymentMethod: '',
    addressShippingNameFull:
      this.props.logged && this.props.user.user.address && this.props.user.user.address.primary
        ? this.props.user.user.address.primary.name.full
        : '',
    addressShippingMobile:
      this.props.logged && this.props.user.user.address && this.props.user.user.address.primary
        ? this.props.user.user.address.primary.mobile
        : '',
    addressNameFull: this.props.logged ? this.props.user.user.managerName : '',
    addressEmail: this.props.logged ? this.props.user.user.email : '',
    addressMobile: this.props.logged ? this.props.user.user.mobile : '',
    addressPhone: this.props.logged ? this.props.user.user.bizNumber : '',
    addressCity: '',
    addressState: '',
    addressAddress1: '',
    addressAddress2: '',
    addressPostCode: '',
    request: '',
    initLoading: true,
    paymentWidget: null,
    paymentMethodsWidget: null,
    paymentAgreement: null,
    // 발급수단 관련
    selectedPaymentType: null,
    documentaryEvidenceInfo: {
      documentType: 'TAX_INVOICE',
      preIssuanceAgreement: false,
      name: this.props.logged ? this.props.user.user.managerName : null,
      contact: this.props.logged ? this.props.user.user.mobile : null,
      sub_contact: null,
      email: this.props.logged ? this.props.user.user.email : null,
      business_no: this.props.logged ? this.props.user.user.bizNumber : null,
      tax_registration_id: null,
      business_item: null,
      business_type: null,
      company_name: this.props.logged ? this.props.user.user.displayName : null,
      representative_name: null,
      business_address: null,
    },
    // 주문자 정보 라디오 버튼 관련
    ordererInfoType: this.props.logged ? 'myInfo' : 'changeInfo',
    savedMyInfo: {
      addressNameFull: this.props.logged ? this.props.user.user.managerName : '',
      addressEmail: this.props.logged ? this.props.user.user.email : '',
      addressMobile: this.props.logged ? this.props.user.user.mobile : '',
      addressPhone: this.props.logged ? this.props.user.user.bizNumber : '',
    },
    // 배송지 정보 라디오 버튼 관련
    shippingInfoType:
      this.props.logged && this.props.user.user.address && this.props.user.user.address.primary
        ? 'recentAddress'
        : 'newAddress',
    // 추적 중복 방지 키
    trackedShippingInfoKey: null,
    trackedPaymentInfoKey: null,
    savedRecentAddress: {
      addressShippingNameFull:
        this.props.logged && this.props.user.user.address && this.props.user.user.address.primary
          ? this.props.user.user.address.primary.name.full
          : '',
      addressShippingMobile:
        this.props.logged && this.props.user.user.address && this.props.user.user.address.primary
          ? this.props.user.user.address.primary.mobile
          : '',
      addressCity:
        this.props.logged && this.props.user.user.address && this.props.user.user.address.primary
          ? this.props.user.user.address.primary.city
          : '',
      addressState:
        this.props.logged && this.props.user.user.address && this.props.user.user.address.primary
          ? this.props.user.user.address.primary.state
          : '',
      addressAddress1:
        this.props.logged && this.props.user.user.address && this.props.user.user.address.primary
          ? this.props.user.user.address.primary.address1
          : '',
      addressAddress2:
        this.props.logged && this.props.user.user.address && this.props.user.user.address.primary
          ? this.props.user.user.address.primary.address2
          : '',
      addressPostCode:
        this.props.logged && this.props.user.user.address && this.props.user.user.address.primary
          ? this.props.user.user.address.primary.postcode
          : '',
    },
  };

  initialize = async () => {
    this.setState({ initLoading: true });
    const { history } = this.props;

    // 로그인 사용자의 경우 세금계산서 목록 불러오기
    if (this.props.logged) {
      // await this.props.TaxInvoiceActions.getTaxInvoiceList();
    }

    try {
      const widgetClientKey = process.env.WIDGET_CLIENT_KEY;
      const customerKey = this.props.logged ? this.props.user.user.id : ANONYMOUS;
      const paymentWidget = await loadPaymentWidget(widgetClientKey, customerKey);

      let cart = {
        items: [],
        total: {
          price: {
            sale: {
              raw: 0,
            },
            original: {
              raw: 0,
            },
          },
          items: {
            price: {
              sale: {
                raw: 0,
              },
              original: {
                raw: 0,
              },
            },
            discounted: {
              raw: 0,
            },
            taxed: {
              raw: 0,
            },
          },
          shipping: {
            fee: {
              sale: {
                raw: 0,
              },
            },
          },
          discounted: {
            raw: 0,
          },
          taxed: {
            raw: 0,
          },
          amount: {
            raw: 0,
          },
          taxes: [
            {
              key: 'KR/VAT',
              taxed: {
                raw: 0,
              },
            },
          ],
          paid: {
            raw: 0,
          },
          cancelled: {
            raw: 0,
          },
          refunded: {
            raw: 0,
          },
        },
      };
      let items = [];
      this.props.cart.items
        .filter(item => item.checked === true)
        .map(item => {
          return items.push({
            ...item,
            price: {
              sale: {
                raw: item.product_price.price,
              },
              original: {
                raw: item.product_price.original_price,
              },
            },
            total: {
              price: {
                sale: {
                  raw: Math.round(item.product_price.price * item.quantity),
                },
                original: {
                  raw: Math.round(item.product_price.original_price * item.quantity),
                },
              },
              taxed: {
                raw: Math.round(item.product_price.price * item.quantity * 0.1),
              },
              discounted: {
                raw: Math.round(
                  (item.product_price.original_price - item.product_price.price) * item.quantity,
                ),
              },
            },
          });
        });
      if (!items.length) history.replace('/cart');
      cart.items = items;
      cart.total.price.sale.raw = items.reduce((acc, cur) => acc + cur.total.price.sale.raw, 0);
      cart.total.price.original.raw = items.reduce(
        (acc, cur) => acc + cur.total.price.original.raw,
        0,
      );
      cart.total.discounted.raw = items.reduce((acc, cur) => acc + cur.total.discounted.raw, 0);
      cart.total.shipping.fee.sale.raw = cart.total.price.sale.raw >= 100000 ? 0 : 3500;
      cart.total.taxed.raw = Math.round(
        items.reduce((acc, cur) => acc + cur.total.taxed.raw, 0) +
          cart.total.shipping.fee.sale.raw * 0.1,
      );
      cart.total.amount.raw =
        cart.total.price.sale.raw + cart.total.shipping.fee.sale.raw + cart.total.taxed.raw;

      if (this.props.logged) {
        if (this.props.user.user.address.primary) {
          this.setState({
            addressShippingNameFull: this.props.user.user.address.primary.name.full,
            addressShippingMobile: this.props.user.user.address.primary.mobile,
            addressCity: this.props.user.user.address.primary.city,
            addressState: this.props.user.user.address.primary.state,
            addressAddress1: this.props.user.user.address.primary.address1,
            addressAddress2: this.props.user.user.address.primary.address2,
            addressPostCode: this.props.user.user.address.primary.postcode,
          });
        }
        await CartActions.getCart(cart);
      } else {
        await CartActions.getAsNonRegisteredCart(cart);
      }
      this.setState({ paymentWidget, initLoading: false });
      this.trackCheckoutStarted(cart);
    } catch (e) {
      console.log(e);
      if (e && e.response) {
        history.replace('/cart');
      }
    }
  };

  trackCheckoutStarted = (cart: any) => {
    if (!cart || !cart.items) return;
    const items = cart.items.map(buildItemFromCartItem);
    const value = cart.total && cart.total.amount ? toNumber(cart.total.amount.raw) : 0;
    track(TRACKING_EVENTS.CHECKOUT_STARTED, { items, value });
  };

  getCartItemsForTracking = (trackingCart: any = this.props.cart) => {
    const cart = trackingCart;
    if (!cart || !cart.items) return [];
    return cart.items.map(buildItemFromCartItem);
  };

  getCartValueForTracking = (trackingCart: any = this.props.cart) => {
    const cart = trackingCart;
    if (!cart || !cart.total || !cart.total.amount) return 0;
    return toNumber(cart.total.amount.raw);
  };

  isShippingInfoComplete = () => {
    return (
      !!this.state.addressShippingNameFull &&
      !!this.state.addressShippingMobile &&
      this.isValidPhoneNumber(this.state.addressShippingMobile) &&
      !!this.state.addressPostCode &&
      !!this.state.addressAddress1 &&
      !!this.state.addressAddress2
    );
  };

  trackShippingInfoAdded = (trackingCart: any = this.props.cart, trackingKey: string = 'current') => {
    if (this.state.trackedShippingInfoKey === trackingKey) return;
    if (!this.isShippingInfoComplete()) return;
    const items = this.getCartItemsForTracking(trackingCart);
    const value = this.getCartValueForTracking(trackingCart);
    track(TRACKING_EVENTS.SHIPPING_INFO_ADDED, { items, value });
    this.setState({ trackedShippingInfoKey: trackingKey });
  };

  trackPaymentInfoAdded = (
    paymentType: string,
    trackingCart: any = this.props.cart,
    trackingKey: string = 'current',
  ) => {
    if (this.state.trackedPaymentInfoKey === trackingKey) return;
    const items = this.getCartItemsForTracking(trackingCart);
    const value = this.getCartValueForTracking(trackingCart);
    track(TRACKING_EVENTS.PAYMENT_INFO_ADDED, { items, value, paymentType });
    this.setState({ trackedPaymentInfoKey: trackingKey });
  };

  syncSelectedPaymentType = (selectedMethod: any) => {
    if (!selectedMethod || selectedMethod.type !== 'CUSTOM') {
      if (this.state.selectedPaymentType) this.setState({ selectedPaymentType: '' });
      return;
    }

    if (selectedMethod.paymentMethodKey === 'bank-transfer') {
      this.setState({ selectedPaymentType: 'BANK_TRANSFER' });
    } else if (selectedMethod.paymentMethodKey === 'post-transfer') {
      this.setState({ selectedPaymentType: 'POST_TRANSFER' });
    }
  };

  getPaymentTypeForTracking = (selectedPaymentMethod: any, paymentMethodInfo: any) => {
    const slug = paymentMethodInfo && paymentMethodInfo.slug;
    const paymentTypeBySlug = {
      tosspayments: 'card',
      'virtual-bank': 'virtual_bank',
      'quick-bank-transfer': 'quick_bank_transfer',
      tosspay: 'tosspay',
      naverpay: 'naverpay',
      kakaopay: 'kakaopay',
      'research-transfer': 'research_card',
      'bank-transfer': 'bank_transfer',
      'post-transfer': 'post_transfer',
    };

    if (slug && paymentTypeBySlug[slug]) return paymentTypeBySlug[slug];
    if (slug) return slug;
    if (selectedPaymentMethod && selectedPaymentMethod.paymentMethodKey) {
      return selectedPaymentMethod.paymentMethodKey.replace(/-/g, '_');
    }
    if (selectedPaymentMethod && selectedPaymentMethod.method) return selectedPaymentMethod.method;
    return 'unknown';
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.paymentWidget !== this.state.paymentWidget) {
      this.renderPaymentWidget();
    }
  }

  componentDidMount() {
    this.initialize();
  }

  renderPaymentWidget = () => {
    const { paymentWidget } = this.state;
    if (!paymentWidget) return;

    const paymentMethodsWidget = paymentWidget.renderPaymentMethods(
      '#payment-widget',
      { value: this.props.cart.total.amount.raw },
      { variantKey: 'DEFAULT' },
    );

    const paymentAgreement = paymentWidget.renderAgreement('#agreement', {
      variantKey: 'AGREEMENT',
    });

    // 위젯 렌더링 완료 후 초기 결제수단 상태만 동기화한다.
    paymentMethodsWidget.on('ready', () => {
      const selectedMethod = paymentMethodsWidget.getSelectedPaymentMethod();
      this.syncSelectedPaymentType(selectedMethod);
    });

    // 결제수단 선택 이벤트 리스너
    paymentMethodsWidget.on('customPaymentMethodSelect', paymentMethodKey => {
      // 무통장 입금 또는 후불 결제 선택 시
      if (paymentMethodKey === 'bank-transfer') {
        this.setState({
          selectedPaymentType: 'BANK_TRANSFER',
          documentaryEvidenceInfo: {
            ...this.state.documentaryEvidenceInfo,
            documentType: 'TAX_INVOICE',
          },
        });
      } else if (paymentMethodKey === 'post-transfer') {
        this.setState({
          selectedPaymentType: 'POST_TRANSFER',
          documentaryEvidenceInfo: {
            ...this.state.documentaryEvidenceInfo,
            documentType: 'TAX_INVOICE',
          },
        });
      }
    });

    // 일반 결제수단 선택 이벤트 리스너: 추적하지 않고 CUSTOM 전용 UI 상태만 정리한다.
    paymentMethodsWidget.on('paymentMethodSelect', paymentMethod => {
      this.syncSelectedPaymentType(paymentMethod);
    });

    // 결제수단 선택 해제 이벤트 리스너
    paymentMethodsWidget.on('customPaymentMethodUnselect', paymentMethodKey => {
      if (paymentMethodKey === 'bank-transfer' || paymentMethodKey === 'post-transfer') {
        this.setState({ selectedPaymentType: '' });
      }
    });

    this.setState({ paymentMethodsWidget, paymentAgreement });
  };

  // 연락처 유효성 검증 함수
  isValidPhoneNumber = value => {
    const numbers = value.replace(/[^\d]/g, '');
    if (numbers.length < 9) return false;
    if (/^(010|011|016|017|018|019)/.test(numbers)) return numbers.length === 11;
    if (numbers.startsWith('02')) return numbers.length >= 9 && numbers.length <= 10;
    if (/^(03[1-9]|04[1-4]|05[1-5]|06[1-4])/.test(numbers))
      return numbers.length >= 10 && numbers.length <= 11;
    return numbers.length >= 9 && numbers.length <= 11;
  };

  // eslint-disable-next-line consistent-return
  onCheckOut = async () => {
    if (!this.state.addressNameFull) return alert('주문자를 입력해야합니다.');
    if (!this.state.addressMobile) return alert('주문자 연락처를 입력해야합니다.');
    if (!this.isValidPhoneNumber(this.state.addressMobile)) {
      return alert('주문자 연락처가 유효하지 않습니다. 올바른 연락처를 입력해주세요.');
    }
    if (!this.state.addressEmail) return alert('주문자 이메일을 입력해야합니다.');
    if (!this.state.addressShippingNameFull) return alert('받는분을 입력해야합니다.');
    if (!this.state.addressShippingMobile) return alert('배송지 연락처를 입력해야합니다.');
    if (!this.isValidPhoneNumber(this.state.addressShippingMobile)) {
      return alert('배송지 연락처가 유효하지 않습니다. 올바른 연락처를 입력해주세요.');
    }
    if (!this.state.addressPostCode)
      return alert('우편번호 찾기 버튼을 눌러 우편번호를 입력해야합니다.');
    if (!this.state.addressAddress2) return alert('상세주소를 입력해야합니다.');
    if (!this.state.checkoutTerms) return alert('이용 약관에 동의해야합니다.');
    if (!this.state.checkoutPrivacy) return alert('개인정보 수집·이용에 동의해야합니다.');

    // 토스페이 위젯 로딩 체크
    const { paymentWidget, paymentMethodsWidget, paymentAgreement } = this.state;

    if (!paymentWidget) {
      alert('결제 위젯이 로드되지 않았습니다. 다시 시도해주세요.');
      return false;
    }

    const selectedPaymentMethod = paymentMethodsWidget.getSelectedPaymentMethod();
    const isPaymentAgreement = paymentAgreement.getAgreementStatus().agreedRequiredTerms;

    if (!selectedPaymentMethod) return alert('결제수단을 선택해주세요.');
    if (!isPaymentAgreement) return alert('결제 서비스 이용 약관을 동의해야합니다.');

    // CUSTOM 타입(무통장입금, 후불결제)에서 세금계산서 정보 검증
    if (selectedPaymentMethod.type === 'CUSTOM') {
      // 후불결제에서 신용카드/연구비카드 선택한 경우는 바이패스
      const isCardPayment =
        selectedPaymentMethod.paymentMethodKey === 'post-transfer' &&
        this.state.documentaryEvidenceInfo.documentType === 'CREDIT_CARD';

      if (!isCardPayment) {
        if (!this.state.documentaryEvidenceInfo.name)
          return alert('세금계산서 담당자명을 입력해주세요.');
        if (!this.state.documentaryEvidenceInfo.email)
          return alert('세금계산서 이메일을 입력해주세요.');
        if (!this.state.documentaryEvidenceInfo.contact)
          return alert('세금계산서 연락처를 입력해주세요.');
        if (!this.state.documentaryEvidenceInfo.company_name)
          return alert('세금계산서 상호/법인명을 입력해주세요.');
        if (!this.state.documentaryEvidenceInfo.business_no)
          return alert('세금계산서 사업자등록번호를 입력해주세요.');
        if (!this.state.documentaryEvidenceInfo.representative_name)
          return alert('세금계산서 대표자명을 입력해주세요.');
        if (!this.state.documentaryEvidenceInfo.business_address)
          return alert('세금계산서 사업장 주소를 입력해주세요.');
      }
    }

    // 결제 방식 매핑
    let paymentMethodInfo = {
      id: 'default',
      name: '디폴트',
      slug: 'default',
    };

    if (selectedPaymentMethod.type === 'NORMAL') {
      if (selectedPaymentMethod.method === '카드') {
        paymentMethodInfo = {
          id: 'WAGPJB49RZSE',
          name: '신용카드',
          slug: 'tosspayments',
        };
      }
      if (selectedPaymentMethod.method === '가상계좌') {
        paymentMethodInfo = {
          id: 'EJVNJM37MA66',
          name: '가상계좌',
          slug: 'virtual-bank',
        };
      }
      if (selectedPaymentMethod.method === '계좌이체') {
        paymentMethodInfo = {
          id: '6KCZUF82JSCW',
          name: '퀵계좌이체',
          slug: 'quick-bank-transfer',
        };
      }
      if (selectedPaymentMethod.method === '간편결제') {
        if (selectedPaymentMethod.easyPay.provider === '토스페이') {
          paymentMethodInfo = {
            id: 'NAGPJB49RZSD',
            name: '토스페이',
            slug: 'tosspay',
          };
        }
        if (selectedPaymentMethod.easyPay.provider === '네이버페이') {
          paymentMethodInfo = {
            id: 'NAGPJB49RZSC',
            name: '네이버페이',
            slug: 'naverpay',
          };
        }
        if (selectedPaymentMethod.easyPay.provider === '카카오페이') {
          paymentMethodInfo = {
            id: 'NAGPJB49RZSE',
            name: '카카오페이',
            slug: 'kakaopay',
          };
        }
      }
    } else if (selectedPaymentMethod.type === 'KEYIN') {
      if (selectedPaymentMethod.method === '카드') {
        paymentMethodInfo = {
          id: 'E2RJQ4BFWLTH',
          name: '연구비카드',
          slug: 'research-transfer',
        };
      }
    } else if (selectedPaymentMethod.type === 'CUSTOM') {
      if (selectedPaymentMethod.paymentMethodKey === 'bank-transfer') {
        paymentMethodInfo = {
          id: '6KCZUF82JSCV',
          name: '무통장입금',
          slug: 'bank-transfer',
        };
      }
      if (selectedPaymentMethod.paymentMethodKey === 'post-transfer') {
        paymentMethodInfo = {
          id: '6KCZUF82JSCL',
          name: '후불결제',
          slug: 'post-transfer',
        };
      }
    }

    // 주문자 정보
    let customer = {
      name: { full: this.state.addressNameFull },
      email: this.state.addressEmail,
      mobile: this.state.addressMobile,
      phone: this.state.addressPhone,
      company: this.props.logged ? this.props.user.user.displayName : '',
      grade: this.props.logged ? this.props.user.user.grade.name : '',
    };

    // 주소 정보
    let address = {
      // 빌링 정보
      billing: {
        address1: this.state.addressAddress1,
        address2: this.state.addressAddress2,
        city: this.state.addressCity,
        country: 'KR',
        company: this.props.logged ? this.props.user.user.displayName : '',
        mobile: this.props.logged ? this.props.user.user.mobile : this.state.addressMobile,
        name: {
          first: null,
          last: null,
          full: this.props.logged ? this.props.user.user.managerName : this.state.addressNameFull,
        },
        phone: this.props.logged ? this.props.user.user.bizNumber : this.state.addressPhone,
        postcode: this.state.addressPostCode,
        state: this.state.addressState,
      },
      // 배송지 정보
      shipping: {
        address1: this.state.addressAddress1,
        address2: this.state.addressAddress2,
        city: this.state.addressCity,
        country: 'KR',
        company: this.props.logged ? this.props.user.user.displayName : '',
        mobile: this.state.addressShippingMobile,
        name: {
          first: null,
          last: null,
          full: this.state.addressShippingNameFull,
        },
        phone: this.state.addressPhone,
        postcode: this.state.addressPostCode,
        state: this.state.addressState,
      },
    };

    // 세금계산서 정보
    let documentaryEvidenceInfo = null;
    if (selectedPaymentMethod.type === 'CUSTOM') {
      documentaryEvidenceInfo = {
        documentType: this.state.documentaryEvidenceInfo.documentType,
        purpose: 'CLAIM',
        price: this.props.cart.total.raw,
        name: this.state.documentaryEvidenceInfo.name,
        contact: this.state.documentaryEvidenceInfo.contact,
        subContact: this.state.documentaryEvidenceInfo.sub_contact,
        email: this.state.documentaryEvidenceInfo.email,
        businessNo: this.state.documentaryEvidenceInfo.business_no,
        taxRegistrationId: this.state.documentaryEvidenceInfo.tax_registration_id,
        businessItem: this.state.documentaryEvidenceInfo.business_item,
        businessType: this.state.documentaryEvidenceInfo.business_type,
        companyName: this.state.documentaryEvidenceInfo.company_name,
        representativeName: this.state.documentaryEvidenceInfo.representative_name,
        businessAddress: this.state.documentaryEvidenceInfo.business_address,
        preIssuanceAgreement: this.state.documentaryEvidenceInfo.preIssuanceAgreement,
        createdAt: new Date().toISOString(),
      };
    }

    let checkoutPayload = {
      _id: `CCBY${new ShortUniqueId({ length: 9, dictionary: 'alphanum_upper' }).rnd()}`,
      items: this.props.cart.items,
      total: this.props.cart.total,
      address,
      customer,
      request: this.state.request,
      documentaryEvidenceInfo,
      transactions: [
        {
          paid: {
            raw: 0,
          },
          cancelled: {
            raw: 0,
          },
          refunded: {
            raw: 0,
          },
          createdAt: {
            raw: null,
          },
          updatedAt: {
            raw: null,
          },
          paymentMethod: paymentMethodInfo,
          vbanks: [],
        },
      ],
    };

    const checkoutTrackingKey = checkoutPayload._id;
    const paymentType = this.getPaymentTypeForTracking(selectedPaymentMethod, paymentMethodInfo);
    this.trackShippingInfoAdded(checkoutPayload, checkoutTrackingKey);
    this.trackPaymentInfoAdded(paymentType, checkoutPayload, checkoutTrackingKey);

    // 결제 정보를 로컬 스토리지에 저장 (결제 완료 후 주문서 생성용)
    const checkoutData = {
      checkoutPayload,
      logged: this.props.logged,
      timestamp: Date.now(),
      isOrderCreated: false,
    };
    localStorage.setItem('pendingCheckout', JSON.stringify(checkoutData));

    if (selectedPaymentMethod.type === 'CUSTOM') {
      this.props.history.push(
        `/checkout-success?orderId=${checkoutPayload._id}&email=${checkoutPayload.customer.email}`,
      );
    }

    const partNumber = checkoutPayload.items[0].product_price.part_number;
    const itemCount = checkoutPayload.items.length - 1;
    const orderName =
      checkoutPayload.items.length > 1 ? `${partNumber} 외 ${itemCount}종` : partNumber;

    // 토스페이 결제 모듈
    try {
      await paymentWidget.requestPayment({
        orderId: checkoutPayload._id,
        orderName,
        customerName: checkoutPayload.customer.name.full,
        customerEmail: checkoutPayload.customer.email,
        customerMobilePhone: checkoutPayload.customer.mobile.replace(/[^0-9]/g, ''),
        successUrl: `${window.location.origin}/checkout-success`,
        failUrl: `${window.location.origin}/checkout-fail`,
      });
    } catch (error) {
      BaseActions.showToast({
        type: 'error',
        message: error.message,
      });
      localStorage.removeItem('pendingCheckout');
    }
  };

  onCheckoutTerms = () => {
    this.setState({
      checkoutTerms: !this.state.checkoutTerms,
      checkoutAll: !this.state.checkoutTerms && this.state.checkoutPrivacy,
    });
  };

  onCheckoutPrivacy = () => {
    this.setState({
      checkoutPrivacy: !this.state.checkoutPrivacy,
      checkoutAll: !this.state.checkoutPrivacy && this.state.checkoutTerms,
    });
  };

  onCheckoutAll = () => {
    this.setState({
      checkoutTerms: !this.state.checkoutAll,
      checkoutPrivacy: !this.state.checkoutAll,
      checkoutAll: !this.state.checkoutAll,
    });
  };

  onCartCoupon = event => {
    this.setState({
      appliedCoupon: event.target.value,
    });
  };

  applyCoupons = async () => {
    const { history } = this.props;
    try {
      const items = [];
      this.props.cart.items
        .filter(item => item.checked === true)
        .map(item => {
          return items.push({
            _id: item._id,
            product: item.product._id,
            variant: item.variant._id,
            quantity: item.quantity,
            shippingMethod: item.shippingMethod._id,
            request: item.request,
            addedAt: item.addedAt.raw,
          });
        });
      // eslint-disable-next-line prefer-destructuring
      const address = this.props.user.user.address.primary;
      delete address.email;
      address.country = 'KR';
      await CartActions.getCart({
        items,
        address: {
          primary: address,
        },
        discount: {
          cart: {
            coupon: this.state.appliedCoupon,
          },
        },
      });
    } catch (e) {
      if (e && e.response) {
        history.replace('/cart');
      }
    }
  };

  applyDiscounts = async () => {
    const { history } = this.props;
    try {
      const items = [];
      this.props.cart.items
        .filter(item => item.checked === true)
        .map(item => {
          return items.push({
            _id: item._id,
            product: item.product._id,
            variant: item.variant._id,
            quantity: item.quantity,
            shippingMethod: item.shippingMethod._id,
            request: item.request,
            addedAt: item.addedAt.raw,
          });
        });
      let payload = {
        items,
      };
      if (this.state.appliedDiscount) {
        payload.discount = {
          cart: {
            discounts: [this.state.appliedDiscount],
          },
        };
      }
      await CartActions.getAsNonRegisteredCart(payload);
    } catch (e) {
      if (e && e.response) {
        history.replace('/cart');
      }
    }
  };

  onPaymentMethod = event => {
    this.setState({
      paymentMethod: event.target.value,
    });
  };

  handleChange = (e: any) => {
    const { name, value, type, checked } = e.target;

    // preIssuanceAgreement 체크박스 처리
    if (name === 'preIssuanceAgreement') {
      this.setState({
        documentaryEvidenceInfo: {
          ...this.state.documentaryEvidenceInfo,
          preIssuanceAgreement: checked,
        },
      });
    } else {
      this.setState({
        [name]: type === 'checkbox' ? checked : value,
      });
    }
  };

  // 발급수단 문서 타입 변경
  onDocumentTypeChange = (e: any) => {
    this.setState({
      documentaryEvidenceInfo: {
        ...this.state.documentaryEvidenceInfo,
        documentType: e.target.value,
      },
    });
  };

  // 발급정보 입력 변경
  onDocumentInfoChange = (field: string, value: string) => {
    this.setState({
      documentaryEvidenceInfo: {
        ...this.state.documentaryEvidenceInfo,
        [field]: value,
      },
    });
  };

  // 발급정보 일괄 업데이트
  onDocumentInfoBulkUpdate = (fields: any) => {
    this.setState({
      documentaryEvidenceInfo: {
        ...this.state.documentaryEvidenceInfo,
        ...fields,
      },
    });
  };

  // 주문자 정보 라디오 버튼 변경 핸들러
  onOrdererInfoTypeChange = (e: any) => {
    const { value } = e.target;
    this.setState({ ordererInfoType: value });

    if (value === 'myInfo') {
      this.onUseMyInfo();
    } else if (value === 'changeInfo') {
      this.onChangeOrdererInfo();
    }
  };

  // 내정보 선택 시 저장된 정보 복원
  onUseMyInfo = () => {
    const { savedMyInfo } = this.state;
    this.setState({
      addressNameFull: savedMyInfo.addressNameFull,
      addressEmail: savedMyInfo.addressEmail,
      addressMobile: savedMyInfo.addressMobile,
      addressPhone: savedMyInfo.addressPhone,
    });
  };

  // 주문자변경 선택 시 입력값 초기화
  onChangeOrdererInfo = () => {
    this.setState({
      addressNameFull: '',
      addressEmail: '',
      addressMobile: '',
      addressPhone: '',
    });
  };

  // 배송지 정보 라디오 버튼 변경 핸들러
  onShippingInfoTypeChange = (e: any) => {
    const { value } = e.target;
    this.setState({ shippingInfoType: value });

    if (value === 'recentAddress') {
      this.onUseRecentAddress();
    } else if (value === 'newAddress') {
      this.onUseNewAddress();
    }
  };

  // 최근 배송지 선택 시 저장된 주소 정보 복원
  onUseRecentAddress = () => {
    const { savedRecentAddress } = this.state;
    this.setState({
      addressShippingNameFull: savedRecentAddress.addressShippingNameFull,
      addressShippingMobile: savedRecentAddress.addressShippingMobile,
      addressAddress1: savedRecentAddress.addressAddress1,
      addressAddress2: savedRecentAddress.addressAddress2,
      addressPostCode: savedRecentAddress.addressPostCode,
    });
  };

  // 새 배송지 선택 시 주소 입력값 초기화
  onUseNewAddress = () => {
    this.setState({
      addressShippingNameFull: '',
      addressShippingMobile: '',
      addressAddress1: '',
      addressAddress2: '',
      addressPostCode: '',
    });
  };

  // eslint-disable-next-line consistent-return
  onFindAddress = async () => {
    if (!this.state.addressNameFull) return alert('주문자를 입력해야합니다.');
    if (!this.state.addressEmail) return alert('이메일을 입력해야합니다.');
    if (!this.state.addressMobile) return alert('연락처를 입력해야합니다.');

    const themeObj = {
      searchBgColor: '#0B65C8',
      queryTextColor: '#FFFFFF',
    };

    // eslint-disable-next-line no-undef
    new daum.Postcode({
      theme: themeObj,
      oncomplete: async (data: any) => {
        // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

        // 각 주소의 노출 규칙에 따라 주소를 조합한다.
        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
        let addr = ''; // 주소 변수

        // 사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
        if (data.userSelectedType === 'R') {
          // 사용자가 도로명 주소를 선택했을 경우
          addr = data.roadAddress;
        } else {
          // 사용자가 지번 주소를 선택했을 경우(J)
          addr = data.jibunAddress;
        }

        const { history } = this.props;
        try {
          this.setState({
            addressAddress1: addr,
            addressAddress2: '',
            addressCity: data.sigungu,
            addressPostCode: data.zonecode,
            addressState: data.sido,
          });
        } catch (e) {
          console.log(e);
          if (e && e.response) {
            history.replace('/cart');
          }
        }
      },
    }).open();
  };

  render() {
    if (this.state.initLoading) return <Circles color="blue" size="medium" text="Loading..." />;

    return (
      <CheckoutTemplate
        logged={this.props.logged}
        cart={this.props.cart}
        user={this.props.user}
        onCheckOut={this.onCheckOut}
        handleChange={this.handleChange}
        checkoutTerms={this.state.checkoutTerms}
        checkoutPrivacy={this.state.checkoutPrivacy}
        checkoutAll={this.state.checkoutAll}
        onCheckoutTerms={this.onCheckoutTerms}
        onCheckoutPrivacy={this.onCheckoutPrivacy}
        onCheckoutAll={this.onCheckoutAll}
        onCartCoupon={this.onCartCoupon}
        applyCoupons={this.applyCoupons}
        applyDiscounts={this.applyDiscounts}
        onPaymentMethod={this.onPaymentMethod}
        onFindAddress={this.onFindAddress}
        addressShippingNameFull={this.state.addressShippingNameFull}
        addressShippingMobile={this.state.addressShippingMobile}
        addressNameFull={this.state.addressNameFull}
        addressEmail={this.state.addressEmail}
        addressMobile={this.state.addressMobile}
        addressPhone={this.state.addressPhone}
        addressState={this.state.addressState}
        addressCity={this.state.addressCity}
        addressAddress1={this.state.addressAddress1}
        addressAddress2={this.state.addressAddress2}
        addressPostCode={this.state.addressPostCode}
        appliedDiscount={this.state.appliedDiscount}
        request={this.state.request}
        isAuthenticated={this.props.logged}
        // 주문자 정보 라디오 버튼 관련 props
        ordererInfoType={this.state.ordererInfoType}
        onOrdererInfoTypeChange={this.onOrdererInfoTypeChange}
        onUseMyInfo={this.onUseMyInfo}
        onChangeOrdererInfo={this.onChangeOrdererInfo}
        // 배송지 정보 라디오 버튼 관련 props
        shippingInfoType={this.state.shippingInfoType}
        onShippingInfoTypeChange={this.onShippingInfoTypeChange}
        onUseRecentAddress={this.onUseRecentAddress}
        onUseNewAddress={this.onUseNewAddress}
        // 발급수단 관련 props
        selectedPaymentType={this.state.selectedPaymentType}
        documentaryEvidenceInfo={this.state.documentaryEvidenceInfo}
        onDocumentTypeChange={this.onDocumentTypeChange}
        onDocumentInfoChange={this.onDocumentInfoChange}
        onDocumentInfoBulkUpdate={this.onDocumentInfoBulkUpdate}
        // Redux 관련 props
        taxInvoiceList={this.props.taxInvoice.list}
        TaxInvoiceActions={this.props.TaxInvoiceActions}
      />
    );
  }
}

export default connect(({ cart, user, pender, shippingAddresses, taxInvoice }: State) => ({
  cart,
  user,
  logged: !!user.user,
  loading: pender.pending['cart/GET_CART'],
  loading1: pender.pending['cart/GET_AS_NON_REGISTERED_CART'],
  shippingAddresses,
  taxInvoice,
  ShippingAddressesActions,
  TaxInvoiceActions,
}))(withRouter(CheckoutTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/checkout/CheckoutTemplateContainer.js